var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RequestGateway {
    constructor(requestService, tokenProcessingGateway, storage, tokenValidator, delay) {
        this.maxTries = 5;
        this.tokenProcessingGateway = tokenProcessingGateway;
        this.requestService = requestService;
        this.storage = storage;
        this.tokenValidator = tokenValidator;
        this.delay = delay;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.storage.getToken();
            if (token && this.tokenValidator.isValidAndLoggedIn(token)) {
                this.tokenProcessingGateway.start(token);
            }
            else {
                yield this.requestNewAnonymousToken();
            }
        });
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.storage.getToken();
            if (token) {
                return token;
            }
            return this.requestNewAnonymousToken();
        });
    }
    requestNewAnonymousToken() {
        if (!this.promiseCache) {
            this.promiseCache = this.getAnonymousTokenAndStartProcessing();
        }
        return this.promiseCache;
    }
    getAnonymousTokenAndStartProcessing() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.getAnonymousTokenWithRetry();
            this.tokenProcessingGateway.start(token);
            this.promiseCache = undefined;
            return token;
        });
    }
    getAnonymousTokenWithRetry() {
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let i = 0; i < this.maxTries; i++) {
                try {
                    const token = yield this.requestService.getAnonymousToken();
                    return token;
                }
                catch (error) {
                    lastError = error;
                }
                if (i !== this.maxTries - 1) {
                    yield this.delay(1000 * (i + 1));
                }
            }
            throw lastError;
        });
    }
    setToken(token) {
        this.tokenProcessingGateway.start(token);
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.storage.getToken();
            if (!token) {
                yield this.requestNewAnonymousToken();
            }
            else if (!this.tokenValidator.isAnonymous(token)) {
                yield this.requestService.logout(token);
                yield this.requestNewAnonymousToken();
            }
        });
    }
    forceLoadAnonymousToken() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestNewAnonymousToken();
        });
    }
}
//# sourceMappingURL=RequestGateway.js.map